import axios from 'axios';
import { enqueue } from './offline-queue';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle token refresh on 401
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}/auth/refresh`, { refreshToken });
          const { accessToken } = response.data.data;
          localStorage.setItem('accessToken', accessToken);
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
        }
      }
    }

    // Offline handling: queue POST/PUT/PATCH/DELETE requests when offline
    if (!navigator.onLine && !originalRequest._offlineQueued) {
      const method = originalRequest.method?.toUpperCase();
      if (method && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
        originalRequest._offlineQueued = true;
        await enqueue(
          method,
          originalRequest.url || '',
          originalRequest.data ? JSON.parse(originalRequest.data) : undefined
        );
        // Return a fake success response so the UI doesn't break
        return {
          data: { success: true, data: null, _offline: true },
          status: 200,
          statusText: 'Queued Offline',
          headers: {},
          config: originalRequest,
        };
      }
    }

    return Promise.reject(error);
  }
);

export default api;
